const data = [
  {
    id: 0,
    ids: 0,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943367943/detail/9ea43555891b4ecca4c3860c8b1f29dc_1699970983190338287.webp',
    topic: 'Combo Cơm tấm sườn, bì, ốp la + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    id: 1,
    href: '/',
    ids: 0,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943372375/detail/897bc2df240940539fe82b69d2dd3bbf_1699970983407574157.webp',
    topic: 'Combo Cơm tấm sườn + Pepsi',
    priceOld: '53.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '48.000',
    note: '',
    state: true,
  },
  {
    id: 2,
    href: '/',
    ids: 0,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943388390/detail/af7e8429dd174631b3e3adf4e3e99616_1699970983614024789.webp',
    topic: 'Combo Cơm tấm sườn, bì, chả + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    ids: 0,
    href: '/',
    id: 3,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943399460/detail/422d551d20a34650902dda5e395f6a03_1699970983854679119.webp',
    topic: 'Combo Cơm tấm sườn, chả + Pepsi',
    priceOld: '58.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    ids: 0,
    href: '/',
    id: 4,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140944407650/detail/a79be601d6584ce79e85d310141e5a7f_1699970984033533974.webp',
    topic: 'Combo Cơm tấm sườn, chả, ốp la + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    ids: 0,
    href: '/',
    id: 5,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140944419714/detail/27d663bc843b41398614fce6215eec56_1699970984235740565.webp',
    topic: 'Combo Cơm tấm sườn, ốp la + Pepsi',
    priceOld: '58.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    id: 6,
    ids: 1,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943367943/detail/9ea43555891b4ecca4c3860c8b1f29dc_1699970983190338287.webp',
    topic: 'Combo Cơm tấm sườn, bì, ốp la + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    id: 7,
    href: '/',
    ids: 1,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943372375/detail/897bc2df240940539fe82b69d2dd3bbf_1699970983407574157.webp',
    topic: 'Combo Cơm tấm sườn + Pepsi',
    priceOld: '53.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '48.000',
    note: '',
    state: true,
  },
  {
    id: 8,
    href: '/',
    ids: 1,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943388390/detail/af7e8429dd174631b3e3adf4e3e99616_1699970983614024789.webp',
    topic: 'Combo Cơm tấm sườn, bì, chả + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    ids: 1,
    href: '/',
    id: 9,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140943399460/detail/422d551d20a34650902dda5e395f6a03_1699970983854679119.webp',
    topic: 'Combo Cơm tấm sườn, chả + Pepsi',
    priceOld: '58.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    ids: 1,
    href: '/',
    id: 10,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140944407650/detail/a79be601d6584ce79e85d310141e5a7f_1699970984033533974.webp',
    topic: 'Combo Cơm tấm sườn, chả, ốp la + Pepsi',
    priceOld: '63.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    ids: 1,
    href: '/',
    id: 11,
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE20231114140944419714/detail/27d663bc843b41398614fce6215eec56_1699970984235740565.webp',
    topic: 'Combo Cơm tấm sườn, ốp la + Pepsi',
    priceOld: '58.000',
    discount: 'Tiết kiệm 5.000 ₫',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    id: 12,
    ids: 2,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CY4CEEJEN2UFRJ/detail/cd9d8648ffda4c7ca7f8a611ccbd8c5c_1600240447679775886.webp',
    topic: 'Cơm sườn + nước sâm',
    priceOld: '',
    discount: '',
    priceNew: '53.000',
    note: '',
    state: true,
  },
  {
    id: 13,
    ids: 2,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CY4CEEJEN2UFRJ/detail/cd9d8648ffda4c7ca7f8a611ccbd8c5c_1600240447679775886.webp',
    topic: 'Cơm sườn ốp la + nước sâm',
    priceOld: '',
    discount: '',
    priceNew: '57.000',
    note: '',
    state: true,
  },
  {
    id: 14,
    ids: 2,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CY4CEEJEN2UFRJ/detail/cd9d8648ffda4c7ca7f8a611ccbd8c5c_1600240447679775886.webp',
    topic: 'Cơm sườn chả + nước sâm',
    priceOld: '',
    discount: '',
    priceNew: '57.000',
    note: '',
    state: true,
  },
  {
    id: 15,
    ids: 2,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CY4CEEJFHF33VE/detail/188b677e6cce40f69e08bd03bb4b19d0_1600240447092703354.webp',
    topic: 'Cơm thịt kho trứng + nước sâm',
    priceOld: '',
    discount: '',
    priceNew: '50.000',
    note: '',
    state: true,
  },
  /*  {
    id: 16,
    ids: 2,
    href: "/",
    src: "https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CY4CEEJFHF33VE/detail/188b677e6cce40f69e08bd03bb4b19d0_1600240447092703354.webp",
    topic: "Cơm thịt kho trứng cút + nước sâm",
    priceOld: "",
    discount: "",
    priceNew: "50.000",
    note: "",
    state: true,
  }, */
  {
    id: 17,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2022042200332589487/detail/menueditor_item_edff4053978a40a0915e04eef18e7a15_1650587577192201568.webp',
    topic: 'Cóm Xíu Mại Sốt Cà Chua',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: '',
    state: true,
  },
  {
    id: 18,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2022011401312857979/detail/menueditor_item_8ee51360251f49049bd3a99fb577d6cb_1642123851575082643.webp',
    topic: 'Cơm Đậu Que Xào Thịt',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: '',
    state: true,
  },
  {
    id: 19,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2020121302202904925/detail/menueditor_item_b028adde3b3240e08b6ded699c54a889_1607825977793781871.webp',
    topic: 'cơm lạp xưởng',
    priceOld: '',
    discount: '',
    priceNew: '35.000',
    note: '',
    state: true,
  },
  {
    id: 20,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2020121302061580306/detail/menueditor_item_4d0e8659b84442b599ef80be4ee27cf4_1607825101366402712.webp',
    topic: 'cơm nem nướng',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: '',
    state: true,
  },
  {
    id: 21,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2020022002220294127/detail/menueditor_item_7745e3bdcc704ffaaeb2d6f55f3f38c3_1582165279850868292.webp',
    topic: 'Cơm ba rọi xào mắm ruốc',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: '',
    state: true,
  },
  {
    id: 22,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2020022002201619840/detail/menueditor_item_3f0d6f0e76084c05b21078c9ad6f5a5b_1582165185620054025.webp',
    topic: 'Cơm heo quay kho cải chua',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: '',
    state: true,
  },
  {
    id: 23,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/5-CYU2NEUKN3CXVN-CYU2NEUTEB3HNX/detail/menueditor_item_b737d563a1f44f9583474d58ab468f7f_1622942409439203787.webp',
    topic: 'Cơm tấm sườn',
    priceOld: '',
    discount: '',
    priceNew: '38.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: true,
  },
  {
    id: 24,
    ids: 3,
    href: '/',
    src: 'https://d1sag4ddilekf6.cloudfront.net/compressed/items/5-CYU2NEUKN3CXVN-CYU2NEUWJUNBV2/photo/75r-24bits-100kb-173fa3855013629fe209737b7a11f203283a2bb26f824f91a59226380d7baa8c-1122c3ce22c241b29a6dff06aca3a326_1563861233479997897.jpeg',
    topic: 'Cơm tấm sườn, ốp la',
    priceOld: '',
    discount: '',
    priceNew: '43.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: true,
  },
  {
    id: 25,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019082504193727446/detail/10c59b2806714cc09062828f1740c3ad_1566706768123330502.webp',
    topic: 'Cơm tấm sườn, bì, chả',
    priceOld: '',
    discount: '',
    priceNew: '48.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: true,
  },
  {
    id: 26,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081601440471450/detail/36fa5811fa884d1097c3a5a794144bab_1565924778063362664.webp',
    topic: 'Cơm trứng chiên thịt',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: true,
  },
  {
    id: 27,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081601433939107/detail/c57b225ad8ae413aa1b1d34650ec6b79_1565924801198612343.webp',
    topic: 'Cơm thịt kho tiêu',
    priceOld: '',
    discount: '',
    priceNew: '37.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: true,
  },
  {
    id: 28,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081601431454288/detail/d98352f82f574a9eb37778fff2999de2_1565924993220545758.webp',
    topic: 'Cơm tấm chả ốp la',
    priceOld: '',
    discount: '',
    priceNew: '33.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: false,
  },
  {
    id: 29,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081601430132644/detail/fd1417fac2f444e1b45a0db553c4086f_1565924952516368368.webp',
    topic: 'Cơm tấm bì ốp la',
    priceOld: '',
    discount: '',
    priceNew: '33.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: false,
  },
  {
    id: 30,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081601423064940/detail/22a0d602365843f59519767bf5a2bfd7_1565924892395378254.webp',
    topic: 'Cơm tấm bì chả',
    priceOld: '',
    discount: '',
    priceNew: '33.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: false,
  },
  {
    id: 31,
    ids: 3,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019082504211232353/detail/7339e6bd31714a18af8f5492245b88e6_1566706865267962420.webp',
    topic: 'Cơm tấm sườn, bì, ốp la',
    priceOld: '',
    discount: '',
    priceNew: '48.000',
    note: 'Giá trên đã bao gồm tiền hộp.',
    state: false,
  },
  {
    id: 32,
    ids: 4,
    href: '/',
    src: '',
    topic: 'Cơm Sườn Ốpla + Pepsi',
    priceOld: '',
    discount: '',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    id: 33,
    ids: 4,
    href: '/',
    src: '',
    topic: 'Cơm Sườn Chả + Pepsi',
    priceOld: '',
    discount: '',
    priceNew: '58.000',
    note: '',
    state: true,
  },
  {
    id: 34,
    ids: 4,
    href: '',
    src: '',
    topic: 'Cơm Sườn + Pepsi',
    priceOld: '',
    discount: '',
    priceNew: '53.000',
    note: 'Cơm Sườn và chai pepsi',
    state: true,
  },
  {
    id: 35,
    ids: 5,
    href: '/',
    src: '',
    topic: 'Cơm Thêm',
    priceOld: '',
    discount: '',
    priceNew: '4.000',
    note: '',
    state: true,
  },
  {
    id: 36,
    ids: 6,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2021120902334336025/detail/menueditor_item_e1ab1884cb2c45edb518ec2bb8b6c796_1639017204579378842.webp',
    topic: 'Pepsi',
    priceOld: '',
    discount: '',
    priceNew: '15.000',
    note: '',
    state: true,
  },
  {
    id: 37,
    ids: 6,
    href: '/',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2019081106174442686/detail/3402376b765f42adbab3f4ae5edfd994_1576086943618453562.webp',
    topic: 'Nước sâm',
    priceOld: '',
    discount: '',
    priceNew: '13.500',
    note: '',
    state: true,
  },
  {
    id: 38,
    ids: 6,
    href: '',
    src: 'https://food-cms.grab.com/compressed_webp/items/VNITE2020072112512149081/detail/7e2ce1290a674348a5021c7360c9d716_1600240446834841752.webp',
    topic: 'Sữa Đậu Nành',
    priceOld: '',
    discount: '',
    priceNew: '13.500',
    note: '',
    state: false,
  },
];
export default data;
